import { SlideFrame } from '../SlideFrame';

export function Slide01Cover() {
  return (
    <SlideFrame pageNum={1} isCover>
      <div className="h-full flex flex-col items-center justify-center pb-24">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src="/triumph-logo.png" alt="Triumph Asset Management" className="w-[696px] h-auto mb-10" />
        <div className="text-[30px] mb-2">Investor Presentation</div>
        <div className="text-[23px] italic text-[#c9a84c]">
          {new Date().toLocaleDateString('en-CA', { year: 'numeric', month: 'long' })}
        </div>
      </div>
    </SlideFrame>
  );
}
